function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNocodb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 251.355,
    x2: 251.355,
    y1: 502.411,
    y2: 51.894,
    gradientTransform: "matrix(1 0 0 -1 0 514)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4351e8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2a1ea5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m128 231.8 58.7 58.8v93H128zm246.7-124.9v267.2c0 5.5-4.5 9.9-10 9.9-2.6 0-5.1-1-7-2.9L128 173.9v-58.6c0-5.5 4.4-9.9 9.9-9.9h.5c2.6 0 5.2 1.1 7 2.9l170.5 147.9V106.9z",
    style: {
      fill: "url(#a)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 102.883,
    x2: 569.674,
    y1: 105.615,
    y2: 570.174,
    gradientTransform: "matrix(1 0 0 -1 0 514)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4351e8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2a1ea5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zm13.5 45.5c-17.7 0-32 14.3-32 32v357c0 17.7 14.3 32 32 32h357c17.7 0 32-14.3 32-32v-357c0-17.7-14.3-32-32-32z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#b)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNocodb);
export default __webpack_public_path__ + "static/media/nocodb.e320f47d01508408d6196457f037ab00.svg";
export { ForwardRef as ReactComponent };